export function adjustmentListConfig(getMoney) {
    return {
        menuType: "button",
        addBtn: false,
        menuWidth: 120,
        menuAlign: "center",
        card: true,
        menu:false,
        delBtn: false,
        editBtn: false,
        align: "center",
        searchMenuSpan: 8,
        columnBtn: false,
        searchBtn: true,
        index: true,
        indexLabel: "序号",
        refreshBtn: true,
        column: [
            {
                label: '项目名称',
                placeholder: "请输入项目名称",
                search: true,
                slot: true,
                prop: "name",
                width: "180",
                fixed: true,
                overHidden: true
            },{
                label: '卖方',
                prop: "sellerCustName",
                search: true,
                searchslot: true,
                searchPlaceholder: "请输入客户名称",
                hide: true,
            },{
                label: "调整状态",
                prop: "auditStatusStr",
                search: true,
                type: "select",
                dicUrl: "/api/blade-system/dict-biz/dictionary?code=contract_state_gz",
                props: {
                  label: "dictValue",
                  value: "dictKey"
                }                
            },
            {
              label: '日期范围',
              prop: 'timePic',
              type:'daterange',
              searchSpan:12,
              searchRange:true,
              search:true,
              hide:true
            }, 
            {
                label: "项目编号",
                prop: "number",
                width: '120'
            },{
                label: "保理类型",
                width: "120",
                prop: "projectTypeStr",
            },{
                label: "融资额度（元）",
                prop: "factoringCredit",
                width: "150",
                formatter: (row, value, label, column) => {
                    return `${getMoney(value)}元`;
                }
            },{
                label: "内部收益率",
                prop: "xirr",
            },{
                label: "业务主办",
                prop: "managerUserName",
            },{
                label: "业务协办",
                prop: "assistUserName",
            },{
                label: "所属部门",
                width: "120",
                overHidden: true,
                prop: "managerDeptName",
            },{
                label: "项目来源",
                prop: "projectComeFromStr",
            },{
                label: "客户名称",
                prop: "buyerCustName",
            },{
                label: "保理商",
                prop: "accountingEntityName",
            },{
                label: "调整审批表",
                prop: "adjustExcel",
                slot: true
            },{
                label: "更新时间",
                width: "120",
                prop: "createTime",
                overHidden: true              
            }
        ]
    }
}

export function adjustmentFilterConfig(selectPersonClick,selectDeptClick) {
    return {
        column: [
            {
              label: '项目名称',
              placeholder: '请输入项目名称',
              prop: "name"
            },{
              label: '客户名称',
              placeholder: '请输入客户名称',
              prop: "sellerCustName"        
            },{
              label: '业务经理',
              prop: 'managerUserName',
              click: () => {
                selectPersonClick();
              }        
            },{
              label: '所属部门',
              prop: 'managerDeptName',
              click: () => {
                selectDeptClick();
              }        
            },{
              label: '业务类型',
              prop: "factoringType",
              type: "select",
              dicUrl: '/api/blade-system/dict-biz/dictionary?code=foctoring_business_type',
              props: {
                label: "dictValue",
                value: "dictKey"
              }
            },{
              label: "是否国有企业",
              prop: "isGoverCompany",
              type: "select",
              labelWidth: 110,
              dicData: [
                {
                  label: "是",
                  value: 1,
                },
                {
                  label: "否",
                  value: 0,
                },
              ],
              display: true,
              hide: true,
              hideshow: true,        
            },{
              label: "是否上市及其关联公司",
              labelWidth: 120,
              prop: "isGoPublic",
              type: "select",
              dicData: [
                {
                  label: "是",
                  value: 1,
                },
                {
                  label: "否",
                  value: 0,
                },
              ],
              display: true,
              hide: true,
              hideshow: true,        
            },{
              label: "是否新三板企业",
              labelWidth: 120,
              prop: "isNewThreeCompay",
              type: "select",
              dicData: [
                {
                  label: "是",
                  value: 1,
                },
                {
                  label: "否",
                  value: 0,
                },
              ],
              display: true,
              hide: true,
              hideshow: true,
            },{
              label: "是否瞪羚企业",
              labelWidth: 110,
              prop: "isGazelleCompany",
              type: "select",
              dicData: [
                {
                  label: "是",
                  value: 1,
                },
                {
                  label: "否",
                  value: 0,
                },
              ],
              display: true,
              hide: true,
              hideshow: true,        
            },{
              label: "客户类型",
              prop: "custType",
              type: "select",
              dicUrl: "/api/blade-system/dict-biz/dictionary?code=cust_type",
              props: {
                label: "dictValue",
                value: "dictKey",
              },
              dataType: "number",
              display: true,
              hide: true,
              hideshow: true,        
            },{
              label: "企业规模",
              type: "select",
              dicUrl: "/api/blade-system/dict-biz/dictionary?code=enterprise_scale",
              prop: 'formEnterpriseScale',
              props: {
                label: "dictValue",
                value: "dictKey"
              }
            },{
              label: "所属行业",
              type: "select",
              dicUrl: "/api/blade-system/dict-biz/dictionary?code=industry_type_all",
              prop: 'formIndustryStr',
              props: {
                label: "dictValue",
                value: "dictKey"
              },
              dataType: "string",
              width: "120"
            },{
              sortable: "custom",
              label: "融资额度",
              prop: "factoringCredit",
              formslot: true,        
            },{
              label: "内部收益率(%)",
              labelWidth: 120,
              prop: "benefitRate",
              display: true,
              formslot: true,        
            },{
              label: "调整状态",
              prop: "flowState",
              type: "select",
              dicUrl: "/api/blade-system/dict-biz/dictionary?code=wf_state",
              props: {
                label: "dictValue",
                value: "dictKey",
              },
              dataType: "string",        
            },{
              label: "审核状态",
              prop: "auditState",
              type: "select",
              search: true,
              dicUrl: "/api/blade-system/dict-biz/dictionary?code=audit_state",
              props: {
                label: "dictValue",
                value: "dictKey",
              },
              dataType: "string",      
            },{
              label: '创建时间',
              prop: 'createTime',
              type: 'datetime',
            }
          ]
    }
}

export function addAdjustmentConfig() {
    return {
        labelWidth: 150,
        emptyBtn: false,
        submitBtn: false,
        column: [
            {
                label: "项目名称",
                prop: "name",
                formslot: true,
                disabled: false,
                alwaysDisabled: false
            },{
                label: "买方(债务人)",
                prop: 'buyerCustName',
                disabled: true,
                alwaysDisabled: true,
                rules: [{
                  required: true,
                  message: "请选择买方",
                  trigger: "change"
                }]
            },{
                // 选择类型
                label: "卖方(债权人)",
                prop: "sellerCustName",
                disabled: true,
                alwaysDisabled: true,
                dicUrl: '/api/blade-/zd/custom/dict',
                dicMethod:'post',
                dicQuery:{
                    custType: 2
                },
                // formslot: true,
                rules: [{
                    required: true,
                    message: "请选择卖方",
                    trigger: "change"
                }]
            },{
                label: '保理商',
                prop: "accountingEntity",
                alwaysDisabled: true,
                disabled: true,
                width: '150',
                type: "select",
                dicUrl: '/api/blade-system/dict-biz/dictionary?code=bl_accounting_entity',
                dataType: 'number',
                props: {
                  label: "dictValue",
                  value: "dictKey"
                },
            },{
                label: '保理类型',
                prop: 'projectTypeStr',
                disabled: true,
                alwaysDisabled: true,
            },{
                label: '调整申请次数',
                prop: 'adjustNumber',
                disabled: true,
                alwaysDisabled: true,
            },{
                label: '保理额度',
                prop: 'factoringCredit',
                append: '元',
                disabled: true,
                alwaysDisabled: true,
            },{
                label: '调整原因及方案',
                prop: 'adjustReason',
                type: 'textarea',
                span: 24,
                disabled: false,
                alwaysDisabled: false,
                rules: [
                    {
                        required: true,
                        message: '请输入调整原因及方案',
                        trigger: 'blur'
                    }
                ]
            }
            // {
            //     label: "调整内容",
            //     prop: "grade",
            //     span: 24,
            //     type: "checkbox",
            //     dicData: [{
            //         label: "批量调息",
            //         value: 1,
            //     },{
            //         label: "利率变更",
            //         value: 2,
            //     },{
            //         label: "调整租金计划",
            //         value: 3,
            //     }]
            // },
        ]
    }
}

export function adjustmentInterestConfig() {
    return {
        refreshBtn:false,
        menu:false,
        addBtn: false,
        showLoading:false,
        showCard:false,
        showBorder: false,
        showStripe: false,
        showHeader: true,
        showIndex: true,
        showCheckbox: false,
        columnBtn: false,
        searchBtn: true,
        submitBtn: false,
        emptyBtn: false,
        column: [
          {
            label: '项目名称',
            prop: 'number'
          },
          {
            label: '合同编号',
            prop: 'name'
          },
          {
            label: '合同金额',
            prop: 'visitPeople'
          },
          {
            label: '批次',
            prop: 'visitTime'
          },
          {
            label: '放款次号',
            prop: 'visitType'
          },
          {
            label: '当前期数',
            prop: 'visitName'
          },
          {
            label: '调整前利率(%)',
            prop: 'visitName'
          },
          {
            label: '利率模式',
            prop: 'visitName'
          },
          {
            label: '剩余期数',
            prop: 'visitName'
          },
          {
            label: '调整后利率(%)',
            prop: 'visitName'
          }
        ]
    }
}

export function adjustmentRateConfig() {
    return {
        refreshBtn:false,
        menu:false,
        addBtn: false,
        showLoading:false,
        showCard:false,
        showBorder: false,
        showStripe: false,
        showHeader: true,
        showIndex: true,
        showCheckbox: false,
        columnBtn: false,
        searchBtn: true,
        submitBtn: false,
        emptyBtn: false,
        column: [
          {
            label: '项目名称',
            prop: 'number'
          },
          {
            label: '合同编号',
            prop: 'name'
          },
          {
            label: '合同金额',
            prop: 'visitPeople'
          },
          {
            label: '批次',
            prop: 'visitTime'
          },
          {
            label: '当前期数',
            prop: 'visitName'
          },
          {
            label: '剩余期数',
            prop: 'visitName'
          },
          {
            label: '利率模式',
            prop: 'visitName'
          },          
          {
            label: '调整前年租息率(%)',
            prop: 'visitName'
          },
          {
            label: '调整后年租息率(%)',
            prop: 'visitName'
          }
        ]
    }
}

export function adjustmentRentConfig() {
    return {
        refreshBtn:false,
        menu:false,
        addBtn: false,
        showLoading:false,
        showCard:false,
        showBorder: false,
        showStripe: false,
        showHeader: true,
        showIndex: true,
        showCheckbox: false,
        columnBtn: false,
        searchBtn: true,
        submitBtn: false,
        emptyBtn: false,
        excelBtn:true,
        border: true,
        index: true,
        expandLevel: 3,
        headerAlign: 'center',
        align: 'center',
        tree: true,
        labelWidth: 140,
        column: [
          {
            label: '期数',
            prop: 'number'
          },
          {
            label: '日期',
            children: [{
              label: '变更前',
              prop: 'beforeChangeDate',
            }, {
              label: '变更后',
              prop: 'afterChangeDate',
            }]
          },
          {
            label: '本金',
            children: [{
              label: '变更前',
              prop: 'beforeChangeNum',
            }, {
              label: '变更后',
              prop: 'afterChangeNum',
            }]
          },
          {
            label: '利息',
            children: [{
              label: '变更前',
              prop: 'beforeChangeIntest',
            }, {
              label: '变更后',
              prop: 'afterChangeIntest',
            }]
          },
          {
            label: '现金流',
            children: [{
              label: '变更前',
              prop: 'beforeChangeIntest',
            }, {
              label: '变更后',
              prop: 'afterChangeIntest',
            }]
          },          
          {
            label: '回笼状态',
            prop: 'visitName'
          }
        ]
    }
}